import { get, post } from "Service";

const ConfrenceCall: (payload: any) => Promise<any> = async (payload) => {
  const request = {
    subUrl: "make-conference-call",
    data: payload,
    isTwilio: true,
  };
  return post(request);
};

const ScheduleMeeting: (payload: any) => Promise<any> = async (payload) => {
  const request = {
    subUrl: "Meetings/schedule",
    data: payload,
  };
  return post(request);
};

const AgoraConferenceCall: (payload: any) => Promise<any> = async (payload) => {
  const request = {
    subUrl: "ConferenceCall/make-agora-conference-call",
    data: payload,
  };
  return post(request);
};

const EndAgoraConferenceCall: (payload: any) => Promise<any> = async (payload) => {
  const request = {
    subUrl: "ConferenceCall/end-agora-conference-call",
    data: payload,
  };
  return post(request);
};

const RejectAgoraConferenceCall: (payload: any) => Promise<any> = async (payload) => {
  const request = {
    subUrl: "ConferenceCall/reject-agora-conference-call",
    data: payload,
  };
  return post(request);
};

const GetCallStatus: (caseId: any) => Promise<any> = async (caseId) => {
  const request = {
    subUrl: `ConferenceCall/call-status/${caseId}`,
  };
  return get(request);
};

export const MeetingApi = {
  ConfrenceCall,
  AgoraConferenceCall,
  ScheduleMeeting,
  EndAgoraConferenceCall,
  RejectAgoraConferenceCall,
  GetCallStatus,
};
